import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { ActionServiceService } from '../action/action.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constant } from 'src/app/shared/service/utils/contant';
import { Action } from 'src/app/shared/models/action';
import { FecthDataService } from 'src/app/shared/service/fetchservice/fetchservice';

@Component({
  selector: 'app-add-action',
  templateUrl: './add-action.component.html',
  styleUrl: './add-action.component.scss'
})


export class AddActionComponent {


  constructor(
    private modalService: NgbModal,

    private paramService:ParameterService,
    private messageService:MessageService,
    private FecthDataService :FecthDataService,
    private ngxService:NgxUiLoaderService,



  ) {

   }

  ngOnInit(){
    this.fetchDataPrograme()
    // Initialize resultatItems as empty array
    this.resultatItems = [];
  }

  close(){
    this.modalService.dismissAll();
  }

  item: Action = new Action();
  programmeData:any=[]
  agenceData:any = [];
  resultatItems:any=[];

  // Method called when programme selection changes
  onProgrammeChange(event: any) {
    const programmeId = event.target.value;
    console.log("programmeId",programmeId);

    if (programmeId) {
      this.getResultatByProgramme(programmeId);
    } else {
      this.resultatItems = [];
      this.item.resultat = null;
    }
  }

  // Fetch results by programme
  getResultatByProgramme(programmeId: any) {
    this.paramService.getResultatByProgramme(programmeId).subscribe(
      (response: any) => {
        //console.log("Résultats par programme:", response);
        this.resultatItems = response.data || [];
      },
      (error: any) => {
        //console.log("Erreur lors de la récupération des résultats:", error);
        this.resultatItems = [];
      }
    );
  }

  addAction(){

    if (!this.item.canSave()) {
      this.messageService.add({ severity: 'info', summary: Constant.suiviTitle, detail: this.item.getErrorMessage() });

    }else{

      this.ngxService.start();

      this.item.programme_id = this.item.programme_id.id;
      this.paramService.addAction(this.item).subscribe(
        (response:any)=>{
          ////console.log("la reponse du webservice",response);

          this.modalService.dismissAll();
          this.messageService.add({ severity: 'success', summary: Constant.suiviTitle, detail: response.message });
          this.FecthDataService.notifySeriviceCreated();
          this.ngxService.stop();
        },
        (error:any)=>{
          const errorMessage = error?.error?.message
            || error?.error?.error
            || error?.message
            || 'Une erreur est survenue';

        //  this.modalService.dismissAll();
          this.messageService.add({ severity: 'error', summary: Constant.suiviTitle, detail: errorMessage  });
          this.FecthDataService.notifySeriviceCreated();
          this.ngxService.stop();


        }
      )
    }

  }

  fetchDataPrograme() {
    this.paramService.fetchDataPrograme().subscribe(
      (response:any)=>{
        this.programmeData = response.data;
        ////console.log("this.programmeData",this.programmeData);
      },
      (error)=>{
        ////console.log("une erreur est survenu",error);
      }
    ) ;
  }

   onSelectProgramme(){

    this.item.code = this.item.programme_id.code + '.'
  }
}
